import { Typography } from '@/components/ui/typography'
import {
  PRICE_ADJUSTMENT_WHEN_TYPE_ACTIVE_UNTIL_DELETED,
  PRICE_ADJUSTMENT_WHEN_TYPE_PERMANENT,
  PRICE_ADJUSTMENT_WHEN_TYPE_SCHEDULED,
} from '@/lib/services/price-adjustments/priceAdjustments.schema'

export function PriceAdjustmentTimingModeNotice({ whenType }) {
  if (whenType === PRICE_ADJUSTMENT_WHEN_TYPE_ACTIVE_UNTIL_DELETED) {
    return (
      <div className="rounded-md bg-status-info-background p-4 text-status-info-foreground ring-1 ring-inset ring-status-info-border">
        <Typography variant="eyebrow" tone="inherit" className="block">
          Starts right away
        </Typography>
        <Typography variant="supporting" tone="inherit" className="mt-2 block">
          This starts as soon as you save and stays active until you remove it.
        </Typography>
      </div>
    )
  }

  if (whenType === PRICE_ADJUSTMENT_WHEN_TYPE_SCHEDULED) {
    return (
      <div className="rounded-xl bg-status-warning-background p-4 text-status-warning-foreground ring-1 ring-inset ring-status-warning-border dark:bg-status-warning-background dark:text-status-warning-foreground dark:ring-status-warning-border">
        <Typography variant="eyebrow" tone="inherit" className="block">
          Scheduled timing
        </Typography>
        <Typography variant="supporting" tone="inherit" className="mt-2 block">
          Choose this when you want to:
        </Typography>
        <ul className="mt-1 ml-5 list-disc space-y-1 text-sm leading-6">
          <li>Start later</li>
          <li>End on a known date</li>
          <li>Repeat yearly or around a holiday</li>
        </ul>
      </div>
    )
  }

  if (whenType === PRICE_ADJUSTMENT_WHEN_TYPE_PERMANENT) {
    return (
      <div className="rounded-xl bg-status-destructive-background p-4 text-status-destructive-foreground ring-1 ring-inset ring-status-destructive-border dark:bg-status-destructive-background dark:text-status-destructive-foreground dark:ring-status-destructive-border">
        <Typography variant="eyebrow" tone="inherit" className="block">
          Permanent change
        </Typography>
        <Typography variant="supporting" tone="inherit" className="mt-2 block">
          This updates matching product prices as soon as you save. It will not create a scheduled
          price change and cannot be automatically undone. To reverse it later, you'll need to save
          another permanent price change in the opposite direction.
        </Typography>
      </div>
    )
  }

  return null
}
